import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react';
import {
  BLUE_COLOR,
  GREEN_COLOR,
  ORANGE_COLOR,
  WHITE_COLOR,
} from '../../../../constants/ColorsConst';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';

const CardEntidades = ({ onPress, data, onDelete, activo, onAdmin }) => {
  return (
    <Card
      onClick={onPress}
      sx={{
        '&:hover': onPress && {
          cursor: 'pointer',
          backgroundColor: blue[100],
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          position: 'relative',
        }}
      >
        <CardMedia
          component="img"
          alt="image fondo"
          height="140"
          image={getFilesArchivos(data.entidad.imgFondo)}
        />
        <Avatar
          alt={data.entidad.nombre}
          src={getFilesArchivos(data.entidad.imgLogo)}
          sx={{
            position: 'absolute',
            right: '.5em',
            top: '.5em',
            width: 70,
            height: 70,
            backgroundColor: 'white',
            p: 0.5,
          }}
        />
        {activo?.id === data.entidad.id && (
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: 'h6',
              color: WHITE_COLOR,
              position: 'absolute',
              left: '.5em',
              bottom: '.5em',
              backgroundColor: GREEN_COLOR,
              p: 0.5,
              borderRadius: 10,
            }}
          >
            ACTIVO
          </Typography>
        )}
      </Box>
      <CardContent sx={{ p: 1 }}>
        <Typography gutterBottom variant="h5" component="div">
          {data.entidad.nombre}
        </Typography>
        <Typography gutterBottom variant="body1" component="div">
          {data.entidad?.direccion?.direccion ?? 'Sin dirección'}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          {data.perfiles.map((el) => {
            return (
              <Typography
                sx={{ fontWeight: 'bold', fontSize: '14pt' }}
                align="center"
              >
                {el.perfil.nombre}
              </Typography>
            );
          })}
          <Typography
            sx={{
              // fontWeight: 'bold',
              fontSize: '14pt',
              color: data.isInvitado ? ORANGE_COLOR : BLUE_COLOR,
            }}
            align="center"
          >
            {data.isInvitado ? 'Invitado' : 'Personal'}
          </Typography>
        </Box>
      </CardContent>

      <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onAdmin} size="small">
          Administrar
        </Button>

        {data.isInvitado && onDelete && (
          <BotonComponent text="Eliminar" click={onDelete} red />
        )}
      </CardActions>
    </Card>
  );
};

export default CardEntidades;
